import {
  Autocomplete,
  GoogleMap,
  MarkerF,
  useLoadScript,
} from '@react-google-maps/api';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import styles from './styles.scoped.css';
import { GOGOLE_API_KEY } from '../../../../env';

export default function Maps({
  autoComplete,
  centerPoint,
  onClick,
  onPlaceChanged,
  options,
}) {
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: GOGOLE_API_KEY,
    libraries: ['places'],
  });
  const containerStyle = {
    width: '100%',
    height: '100%',
  };
  const [autocomplete, setAutocomplete] = useState(null);

  return (
    isLoaded && (
      <GoogleMap
        center={centerPoint}
        id="marker-merchant"
        mapContainerStyle={containerStyle}
        onClick={onClick}
        options={options}
        zoom={17}
      >
        <MarkerF position={centerPoint} />
        {autoComplete && (
          <Autocomplete
            onLoad={(autocomplete) => setAutocomplete(autocomplete)}
            onPlaceChanged={() => onPlaceChanged(autocomplete)}
          >
            <div
              className={styles.autocompleteField}
              style={{
                position: 'absolute',
                top: '0.5rem',
                right: '0.5rem',
              }}
            >
              <input placeholder="Cari alamat" type="text" />
            </div>
          </Autocomplete>
        )}
      </GoogleMap>
    )
  );
}

Maps.propTypes = {
  autoComplete: PropTypes.bool,
  centerPoint: PropTypes.object,
  onClick: PropTypes.func,
  onPlaceChanged: PropTypes.func,
  options: PropTypes.object,
};
